import React from "react";
import { ProductDescWrap } from "./ProductDesc.styled";

const ProductDesc = () => {
  return (
    <ProductDescWrap>
      <h3>Product Description</h3>
      <p>
        Welcome to the world of natural and organic. Here you can discover the
        bounty of nature. We have grown on the principles of health, ecology,
        and care. We aim to give our customers a healthy chemical-free meal for
        perfect nutrition. It offers about 8-10% carbs. Simple sugars — such as
        glucose and fructose — make up 70% and 80% of the carbs in raw.
      </p>
    </ProductDescWrap>
  );
};

export default ProductDesc;
